import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MainComponent } from './main.component';
import { AppbarComponent } from './appbar/appbar.component';
import { MenuComponent } from './menu/menu.component';

//jqwidgets
import { jqxPopoverModule } from 'jqwidgets-ng/jqxpopover';
import { jqxMenuModule } from 'jqwidgets-ng/jqxmenu';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { jqxWindowModule } from 'jqwidgets-ng/jqxwindow';

import { ToastrModule, ToastrService } from 'ngx-toastr';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { AccionesModule } from '../acciones/acciones.module';
import { CloneMenuModule } from '../clone-menu/clone-menu.module';
import { EditMenuModule } from '../edit-menu/edit-menu.module';
import { AppMenuModule } from '../app-menu/app-menu.module';
import { AppMenuEmpModule } from '../app-menu-emp/app-menu.emp.module';
import { ModulosMenuModule } from '../modulos-menu/modulos-menu.module';
import { AppModuloEmpModule } from '../app-modulo-emp/app-modulo-emp.module';
import { ApartadosModule } from '../apartados/apartados.module';
import { AppApartadosModule } from '../app-apartados/app-apartados.module';
import { RolesPermissionsModule } from '../roles-permissions/roles-permissions.module';
import { NzModalModule } from 'ng-zorro-antd/modal';

@NgModule({
  declarations: [
    MainComponent,
    AppbarComponent,
    MenuComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AccionesModule,
    CloneMenuModule,
    EditMenuModule,
    AppMenuModule,
    AppMenuEmpModule,
    jqxPopoverModule,
    jqxMenuModule,
    jqxGridModule,
    jqxButtonModule,
    jqxInputModule,
    jqxWindowModule,
    jqxLoaderModule,
    ToastrModule.forRoot(),
    ModulosMenuModule,
    AppModuloEmpModule,
    ApartadosModule,
    AppApartadosModule,
    RolesPermissionsModule,
    NzModalModule,
  ],
})
export class MainModule {}
